import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { UserProfile, Role, Gelanggang } from '../types';
import { getMembersDB, saveMemberDB, getNextMemberId, syncGoogleUserWithTursoDB } from '../services/db';
import { auth, signInWithGooglePopup, signOutFirebase } from '../lib/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { getStoredUserSession, persistUserSession, getSessionIndexedDB } from '../utils/sessionVault';


export const QUICK_LOGIN_PROFILES = {
  Pengerusi: {
    id: 'asmm-001',
    name: 'Mohd Hafife Bin Abd Halim',
    icNo: '850612025431',
    email: 'hafife@asmm.org.my',
    phone: '0194589201',
    address: 'No. 1, Jalan Warisan, Taman Warisan, 09600 Lunas, Kedah',
    role: 'Pengerusi',
    gelanggang: 'Semua Gelanggang',
    bengkung: 'Kuning 5 (Guru Muda)',
    bengkungBadge: '/badges/kuning5-5th-degree-instructor-jurulatih-kanan.png',
    photoUrl: '/badges/hafife.jpeg',
    joinedDate: '2018-03-15',
    status: 'Aktif',
  },
  'Timbalan Pengerusi': {
    id: 'asmm-002',
    name: 'Zulkifli Bin Saad',
    icNo: '790415025121',
    email: 'zulkifli@asmm.org.my',
    phone: '0195829104',
    address: 'No. 12, Lorong Melati, Taman Melati, 09000 Kulim, Kedah',
    role: 'Timbalan Pengerusi',
    gelanggang: 'Semua Gelanggang',
    bengkung: 'Kuning 5 (Jurulatih Kanan)',
    bengkungBadge: '/badges/kuning5-5th-degree-instructor-jurulatih-kanan.png',
    photoUrl: '/badges/zulkifli.jpeg',
    joinedDate: '2018-03-15',
    status: 'Aktif',
  },
  Setiausaha: {
    id: 'asmm-003',
    name: 'Mohd Fauzi Bin Abd Aziz',
    icNo: '800114025309',
    email: 'fauzi@asmm.org.my',
    phone: '0124475157',
    address: 'No. 45, Kampung Padang Meha, 09400 Padang Serai, Kedah',
    role: 'Setiausaha',
    gelanggang: 'Wadi AnNour',
    bengkung: 'Kuning 5 (Jurulatih Kanan)',
    bengkungBadge: '/badges/kuning5-5th-degree-instructor-jurulatih-kanan.png',
    photoUrl: '/badges/fauzi.jpeg',
    joinedDate: '2019-06-20',
    status: 'Aktif',
  },
  'Pen. Setiausaha': {
    id: 'asmm-004',
    name: 'Mohammad Syah Firafizal Bin Abubakar',
    icNo: '871109025401',
    email: 'syah@asmm.org.my',
    phone: '0195810293',
    address: 'No. 8, Jalan Bersatu, 09600 Lunas, Kedah',
    role: 'Pen. Setiausaha',
    gelanggang: 'Semua Gelanggang',
    bengkung: 'Merah 3 (Pembantu Jurulatih Sulung)',
    bengkungBadge: '/badges/merah3-pembantu-jurulatih-sulung.png',
    photoUrl: '/badges/syah-firafizal.jpeg',
    joinedDate: '2020-02-10',
    status: 'Aktif',
  },
  Bendahari: {
    id: 'asmm-005',
    name: 'Mohd Aizat Bin Yusoff',
    icNo: '900514025201',
    email: 'aizat@asmm.org.my',
    phone: '0174820194',
    address: 'No. 23, Taman Mahsuri, 09600 Lunas, Kedah',
    role: 'Bendahari',
    gelanggang: 'Semua Gelanggang',
    bengkung: 'Kuning 0 (Penolong Jurulatih)',
    bengkungBadge: '/badges/kuning0-penolong-jurulatih.png',
    photoUrl: '/badges/aizat.jpeg',
    joinedDate: '2024-01-15',
    status: 'Aktif',
  },
  'Ketua Gelanggang': {
    id: 'asmm-006',
    name: 'Fikriz Zaki Syeikh Ahmad Amirruddin',
    icNo: '950218026115',
    email: 'zaki@asmm.org.my',
    phone: '0135819201',
    address: 'No. 7, Jalan Anggerik 2, 09000 Kulim, Kedah',
    role: 'Ketua Gelanggang',
    gelanggang: 'Pusaka Warisan',
    bengkung: 'Kuning 5 (Jurulatih Kanan)',
    bengkungBadge: '/badges/kuning5-5th-degree-instructor-jurulatih-kanan.png',
    photoUrl: '/badges/zaki.jpeg',
    joinedDate: '2022-05-18',
    status: 'Aktif',
  },
  AJK: {
    id: 'asmm-008',
    name: 'Shahrul Aswad Bin Shamsuri',
    icNo: '910405026105',
    email: 'aswad@asmm.org.my',
    phone: '0134829104',
    address: 'No. 15, Taman Desa Aman, 09400 Padang Serai, Kedah',
    role: 'AJK',
    gelanggang: 'Semua Gelanggang',
    bengkung: 'Merah 2 (Pembantu Jurulatih Kanan)',
    bengkungBadge: '/badges/merah2-pembantu-jurulatih-kanan.png',
    photoUrl: '/badges/aswad.jpeg',
    joinedDate: '2021-04-12',
    status: 'Aktif',
  },
  Superadmin: {
    id: 'asmm-011',
    name: 'Mohammad Hafiz Bin Halim',
    icNo: '030819025819',
    email: 'meisterhafiz@gmail.com',
    phone: '0194920194',
    address: 'No. 88, Jalan Pusaka 1, 09600 Lunas, Kedah',
    role: 'Ahli',
    gelanggang: 'Pusaka Warisan',
    bengkung: 'Putih 1 (Pesilat Muda)',
    bengkungBadge: '/badges/putih1-pesilat-muda.png',
    photoUrl: '/badges/hafiz.jpeg?v=2',
    joinedDate: '2024-04-10',
    status: 'Aktif',
  },
  Ahli: {
    id: 'asmm-010',
    name: 'Mohd Shukor Bin Sahidin',
    icNo: '020719026192',
    email: 'shukor@asmm.org.my',
    phone: '0194810293',
    address: 'No. 19, Kampung Sungai Seluang, 09600 Lunas, Kedah',
    role: 'Ahli',
    gelanggang: 'Wadi AnNour',
    bengkung: 'Merah 2 (Pembantu Jurulatih Kanan)',
    bengkungBadge: '/badges/merah2-pembantu-jurulatih-kanan.png',
    photoUrl: '/badges/shukor.jpeg',
    joinedDate: '2024-03-01',
    status: 'Aktif',
  },
  'Ahli Seumur Hidup': {
    id: 'ASMM-010',
    name: 'Mohd Shukor Bin Sahidin',
    icNo: '020719026192',
    email: 'shukor@asmm.org.my',
    phone: '0194810293',
    address: 'No. 19, Kampung Sungai Seluang, 09600 Lunas, Kedah',
    role: 'Ahli Seumur Hidup',
    roles: ['Ahli Seumur Hidup'],
    gelanggang: 'Wadi AnNour',
    bengkung: 'Merah 2 (Pembantu Jurulatih Kanan)',
    bengkungBadge: '/badges/merah2-pembantu-jurulatih-kanan.png',
    photoUrl: '/badges/shukor.jpeg',
    joinedDate: '2024-03-01',
    status: 'Aktif',
  },
  Waris: {
    id: 'ASMM-015',
    name: 'Zainab Binti Ismail',
    icNo: '800812025114',
    email: 'zainab@gmail.com',
    phone: '0194820194',
    address: 'No. 12, Jalan Sejahtera 3, Taman Sejahtera, 09600 Lunas, Kedah',
    role: 'Waris',
    roles: ['Waris'],
    gelanggang: 'Pusaka Warisan',
    bengkung: '' as any,
    bengkungBadge: '',
    photoUrl: '/default-avatar.svg',
    joinedDate: '2026-08-15',
    status: 'Aktif',
  }
} as Record<string, UserProfile>;

interface AuthContextType {
  currentUser: UserProfile | null;
  selectedChildId: string | null;
  setSelectedChildId: (id: string | null) => void;
  selectedGelanggang: Gelanggang;
  setSelectedGelanggang: (g: Gelanggang) => void;
  setCurrentUser: (user: UserProfile | null) => void;
  loginAs: (role: Role | string) => void;
  loginByIc: (icNo: string, members: UserProfile[]) => UserProfile | null;
  loginWithGoogle: (
    onExistingEmailFound?: (
      existingMember: UserProfile,
      googleUser: { uid: string; email: string; displayName?: string | null; photoURL?: string | null }
    ) => void
  ) => Promise<UserProfile | null>;
  bindGoogleAccount: (
    targetMember: UserProfile,
    googleUser: { uid: string; email?: string | null; displayName?: string | null; photoURL?: string | null }
  ) => Promise<UserProfile>;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentUser, setCurrentUserState] = useState<UserProfile | null>(() => {
    return getStoredUserSession();
  });

  const [selectedChildId, setSelectedChildIdState] = useState<string | null>(() => {
    try {
      return localStorage.getItem('asmm_selected_child_id_v2');
    } catch {
      return null;
    }
  });

  const setSelectedChildId = useCallback((id: string | null) => {
    setSelectedChildIdState(id);
    if (id) {
      localStorage.setItem('asmm_selected_child_id_v2', id);
    } else {
      localStorage.removeItem('asmm_selected_child_id_v2');
    }
  }, []);

  const [selectedGelanggang, setSelectedGelanggangState] = useState<Gelanggang>(() => {
    try {
      const saved = localStorage.getItem('asmm_selected_gelanggang_v2');
      return (saved as Gelanggang) || 'Semua Gelanggang';
    } catch {
      return 'Semua Gelanggang';
    }
  });

  const setSelectedGelanggang = (g: Gelanggang) => {
    setSelectedGelanggangState(g);
    localStorage.setItem('asmm_selected_gelanggang_v2', g);
  };

  const setCurrentUser = useCallback((user: UserProfile | null) => {
    setCurrentUserState(user);
    persistUserSession(user);
  }, []);

  // Ensure active currentUser is always synchronized across all session storage tiers
  useEffect(() => {
    if (currentUser) {
      persistUserSession(currentUser);
    }
  }, [currentUser]);

  // Re-sync currentUser with latest data from DB (e.g. address, phone, bengkung, role, etc.)
  const syncCurrentUserFromDb = useCallback(async () => {
    if (!currentUser?.id && !currentUser?.icNo) return;
    try {
      const members = await getMembersDB();
      const currentIcClean = (currentUser.icNo || '').replace(/[\s-]/g, '').trim();
      const found = members.find(m => 
        (currentUser.id && m.id && m.id.toUpperCase() === currentUser.id.toUpperCase()) ||
        (currentIcClean && (m.icNo || '').replace(/[\s-]/g, '').trim() === currentIcClean)
      );
      if (found) {
        const hasDiff = 
          found.address !== currentUser.address ||
          found.phone !== currentUser.phone ||
          found.email !== currentUser.email ||
          found.name !== currentUser.name ||
          found.icNo !== currentUser.icNo ||
          found.role !== currentUser.role ||
          JSON.stringify(found.roles || []) !== JSON.stringify(currentUser.roles || []) ||
          found.gelanggang !== currentUser.gelanggang ||
          found.bengkung !== currentUser.bengkung ||
          found.bengkungBadge !== currentUser.bengkungBadge ||
          found.photoUrl !== currentUser.photoUrl ||
          found.occupation !== currentUser.occupation ||
          found.kinName !== currentUser.kinName ||
          found.kinPhone !== currentUser.kinPhone ||
          found.status !== currentUser.status ||
          found.sessionTime !== currentUser.sessionTime;

        if (hasDiff) {
          setCurrentUser({ ...currentUser, ...found });
        }
      }
    } catch (err) {
      console.warn('syncCurrentUserFromDb err:', err);
    }
  }, [currentUser, setCurrentUser]);

  useEffect(() => {
    syncCurrentUserFromDb();

    const handleUpdate = () => {
      syncCurrentUserFromDb();
    };

    window.addEventListener('asmm_db_updated', handleUpdate);
    window.addEventListener('storage', handleUpdate);
    return () => {
      window.removeEventListener('asmm_db_updated', handleUpdate);
      window.removeEventListener('storage', handleUpdate);
    };
  }, [syncCurrentUserFromDb]);

  // Background session resilience: If currentUser is null after a full storage wipe (e.g. Chrome clear cache extension),
  // check IndexedDB and Firebase Auth to automatically restore session without forcing logout.
  useEffect(() => {
    if (!currentUser && typeof window !== 'undefined') {
      const isLoggedOut = localStorage.getItem('asmm_user_logged_out') === 'true' ||
                          sessionStorage.getItem('asmm_user_logged_out') === 'true';
      if (!isLoggedOut) {
        getSessionIndexedDB().then((idbUser) => {
          if (idbUser && (idbUser.id || idbUser.icNo)) {
            setCurrentUser(idbUser);
          }
        }).catch(() => {});
      }
    }
  }, [currentUser, setCurrentUser]);

  // Firebase Auth background persistence listener
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (fbUser) => {
      if (fbUser && !currentUser && typeof window !== 'undefined') {
        const isLoggedOut = localStorage.getItem('asmm_user_logged_out') === 'true' ||
                            sessionStorage.getItem('asmm_user_logged_out') === 'true';
        if (!isLoggedOut) {
          try {
            const members = await getMembersDB();
            const email = (fbUser.email || '').toLowerCase().trim();
            const matched = members.find(m => 
              (m.firebaseUid && m.firebaseUid === fbUser.uid) ||
              (email && m.email && m.email.toLowerCase().trim() === email)
            );
            if (matched) {
              setCurrentUser(matched);
            }
          } catch {}
        }
      }
    });
    return () => unsubscribe();
  }, [currentUser, setCurrentUser]);

  const loginAs = useCallback(async (role: Role | string) => {
    const profile = QUICK_LOGIN_PROFILES[role];
    if (profile) {
      try {
        const members = await getMembersDB();
        const found = members.find(m => 
          (m.id && profile.id && m.id.toUpperCase() === profile.id.toUpperCase()) ||
          (profile.icNo && m.icNo && m.icNo.trim() === profile.icNo.trim())
        );
        if (found) {
          setCurrentUser(found);
          return;
        }
      } catch {}
      setCurrentUser(profile);
    }
  }, [setCurrentUser]);

  /**
   * Real login: Match IC number against the member database.
   * Returns the matched member profile or null if not found.
   */
  const loginByIc = useCallback((icNo: string, members: UserProfile[]): UserProfile | null => {
    const normalizedIc = icNo.replace(/[\s-]/g, '');
    const found = members.find(m => m.icNo.replace(/[\s-]/g, '') === normalizedIc);
    if (found) {
      setCurrentUser(found);
      return found;
    }
    return null;
  }, [setCurrentUser]);

  /**
   * Bind Google Firebase credentials to an existing UserProfile and log in.
   * Merges all duplicate records with the same email and syncs directly with Turso DB.
   */
  const bindGoogleAccount = useCallback(async (
    targetMember: UserProfile,
    googleUser: { uid: string; email?: string | null; displayName?: string | null; photoURL?: string | null }
  ): Promise<UserProfile> => {
    const { member } = await syncGoogleUserWithTursoDB({
      uid: googleUser.uid,
      email: googleUser.email || targetMember.email,
      displayName: googleUser.displayName || targetMember.name,
      photoURL: googleUser.photoURL || targetMember.photoUrl
    });

    setCurrentUser(member);
    window.dispatchEvent(new Event('asmm_db_updated'));
    return member;
  }, [setCurrentUser]);

  /**
   * Google Sign-In & Sign-Up Flow:
   * 1. Signs in via Firebase Google popup.
   * 2. Checks if firebaseUid or email exists in Turso / ASMM database.
   * 3. If email exists and onExistingEmailFound callback is passed, triggers callback for confirmation modal.
   * 4. Merges same email records without creating duplicates.
   * 5. Saves directly to Turso DB and LocalStorage.
   */
  const loginWithGoogle = useCallback(async (
    onExistingEmailFound?: (
      existingMember: UserProfile,
      googleUser: { uid: string; email: string; displayName?: string | null; photoURL?: string | null }
    ) => void
  ): Promise<UserProfile | null> => {
    const userCredential = await signInWithGooglePopup();
    const googleUser = userCredential.user;
    const userEmail = (googleUser.email || '').toLowerCase().trim();
    const googleUid = googleUser.uid;

    const members = await getMembersDB();

    // 1. Check by firebaseUid first (already bound previously)
    const matchedUid = members.find(m => m.firebaseUid && m.firebaseUid === googleUid);
    if (matchedUid) {
      const { member } = await syncGoogleUserWithTursoDB(googleUser);
      setCurrentUser(member);
      window.dispatchEvent(new Event('asmm_db_updated'));
      return member;
    }

    // 2. Check if email already exists in DB (not yet linked to this UID)
    const matchedEmail = userEmail ? members.find(m =>
      m.email && m.email.toLowerCase().trim() === userEmail
    ) : undefined;

    if (matchedEmail) {
      // If caller requested confirmation modal via callback, let caller handle binding dialog
      if (onExistingEmailFound) {
        onExistingEmailFound(matchedEmail, {
          uid: googleUid,
          email: userEmail,
          displayName: googleUser.displayName,
          photoURL: googleUser.photoURL
        });
        return null;
      }

      // Default: Link and login directly
      return await bindGoogleAccount(matchedEmail, {
        uid: googleUid,
        email: userEmail,
        displayName: googleUser.displayName,
        photoURL: googleUser.photoURL
      });
    }

    // 3. New visitor: Provision new member profile directly into Turso
    const { member } = await syncGoogleUserWithTursoDB(googleUser);
    setCurrentUser(member);
    window.dispatchEvent(new Event('asmm_db_updated'));
    return member;
  }, [setCurrentUser, bindGoogleAccount]);


  const logout = useCallback(() => {
    signOutFirebase().catch(() => { });
    setCurrentUser(null);
    setSelectedChildId(null);
  }, [setCurrentUser, setSelectedChildId]);

  return (
    <AuthContext.Provider
      value={{
        currentUser,
        selectedChildId,
        setSelectedChildId,
        selectedGelanggang,
        setSelectedGelanggang,
        setCurrentUser,
        loginAs,
        loginByIc,
        loginWithGoogle,
        bindGoogleAccount,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};


export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
